export enum Session {
  KEEP,
  LOGOUT
}
